import { put, select, take } from 'redux-saga/effects';
import notification from 'antd/lib/notification';
// internal
import { ProjectType } from '@app/store/typings/actions/project';
import { BrandType } from '@app/store/typings/actions/brand';
import { RootState } from '@app/store/typings/state/root';
import * as Action from '@app/store/typings/actions/user.d';
import * as Service from '@app/services/user';
import * as ProjectService from '@app/services/project';
import { handleError } from '@app/utils/service';
import { getProject, getRowsPerPage } from '@app/utils/localStorage';
import { FilterEndUser } from '@app/typings/services/user';
import { getFilterProjectEndUser } from '@app/utils/lockrStorage';

const { filters, pages }: FilterEndUser = getFilterProjectEndUser();

export function* inviteUserInProject({ payload }: Action.InviteUserInProject) {
  try {
    const { data } = yield Service.inviteUser(
      payload.email,
      false,
      payload.roleId,
      payload.groupIds || undefined,
    );
    if (data.success) {
      notification.success({ message: 'Success', description: 'Invite user successfully' });
      const state: {
        projectId: string;
        offset: number;
        limit: number;
      } = yield select((state: RootState) => ({
        projectId: state.project.currentProject._id,
        offset: state.user.projectMeta.offset,
        limit: state.user.projectMeta.limit,
      }));
      yield put<ProjectType>({
        type: 'KEY_PROJECT_FETCH_WITHID',
        payload: state.projectId,
      });
      yield take('KEY_PROJECT_SET_WITHID');
      yield put<Action.UserType>({
        type: 'KEY_USER_FETCH_INPROJECT',
        payload: {
          filters,
          pages: { offset: 0, limit: parseInt(getRowsPerPage()) },
        },
      });
    }
  } catch (error: any) {
    const message = error.response.data.message;
    notification.error({ message: 'Error', description: message });
    handleError(error);
  }
}

export function* inviteUserInBrand({ payload }: Action.InviteUserInBrand) {
  try {
    const { data } = yield Service.inviteUser(payload.email, true, payload.roleId);
    if (data.success) {
      notification.success({ message: 'Success', description: 'Invite admin successfully' });
      const state: {
        brandId: string;
        offset: number;
        limit: number;
      } = yield select((state: RootState) => ({
        brandId: state.brand.currentBrand._id,
        offset: state.user.brandMeta.offset,
        limit: state.user.brandMeta.limit,
      }));
      yield put<BrandType>({
        type: 'KEY_BRAND_FETCH_WITHID',
        payload: state.brandId,
      });
      yield take('KEY_BRAND_SET_WITHID');
      yield put<Action.UserType>({
        type: 'KEY_USER_FETCH_INBRAND',
        payload: { offset: state.offset, limit: state.limit },
      });
    }
  } catch (error: any) {
    const message = error.response.data.message;
    notification.error({ message: 'Error', description: message });
    handleError(error);
  }
}

export function* inviteUserMember({ payload }: Action.InviteUserMember) {
  try {
    const { data } = yield ProjectService.inviteMember(getProject(), {
      firstName: payload.firstName,
      lastName: payload.lastName,
      email: payload.email,
      roleId: payload.roleId,
    });
    if (data.success) {
      notification.success({ message: 'Success', description: 'Invite member successfully' });
      yield put<Action.UserType>({
        type: 'KEY_USER_FETCH_INPROJECT',
        payload: {
          filters,
          pages: { offset: 0, limit: pages.limit || parseInt(getRowsPerPage()) },
        },
      });
    }
  } catch (error: any) {
    const message = error.response.data.message;
    notification.error({ message: 'Error', description: message });
    handleError(error);
  }
}
